import { ProgressStatus } from 'constants/progressStatus';

export const isPassed = (status: number) => status === ProgressStatus.PASSED;

export const isFailed = (status: number) => status === ProgressStatus.FAILED;

export const isInProgress = (status: number) => status === ProgressStatus.IN_PROGRESS;
